
export default function getStatusSetting(status){
  let statusColor = "";

  if(status===0){
    statusColor = "rgba(112, 182, 3, 1)";
  }else if(status===1){
    statusColor = "rgba(245, 154, 35, 1)";
  }else if(status===2){
    statusColor = "rgba(163, 0, 20, 1)";
  }

  let statusStyle = "margin-left: 5px;color:white;border:1px solid "+statusColor+";background:"+statusColor;

  return {statusStyle:statusStyle,statusColor:statusColor}
}
